import { createContext, Dispatch, SetStateAction } from 'react'

interface ICompleteScreeningContext {
  nextStep: () => void
  handleNextStep?: () => void
  handlePreviousStep?: () => Promise<void>
  isDriverLicenses?: boolean
  setIsDriverLicenses?: Dispatch<SetStateAction<boolean>>
}

export const CompleteScreeningContext = createContext<ICompleteScreeningContext>({} as ICompleteScreeningContext)
